<app-barra-consulta
  *ngIf="!carregando" visible="false"
  [listagemComFiltros]="getListagemComFiltros()"
  (atualizando)="atualizar($event)"
  (inserindo)="novo($event)"
  (definirFiltro)="definirFiltragem()"
  [exibirNovo]="exibirBotaoNovo"
  [detalhe]="detalhe">
</app-barra-consulta>
<div class="conteudo">
  <app-loading [exibir]="carregando"></app-loading>
  <div *ngIf="!carregando">
    <app-gridview   
      [ExibirBotaoDetalhes]="exibirBotaoDetalhes"
      [ExibirIconBotaoDetalhes]="exibirIconBotaoDetalhes"
      [ExibirBotaoDetalhesIcon]="exibirBotaoDetalhesIcon"
      [NomeModulo]="nomeModulo" 
      [totalInterna]="visualizarTotalInterna"
      [totalGeral]="visualizarTotalGeral"
      [visualizarTotalRegistros]="visualizarTotalRegistros"
      [PaginaAtual]="paginaAtual"
      [QuantidadeRegistrosPorPagina]="QuantidadeRegistrosPorPagina"
      [Paginacao]="listagemComPaginacao"
      [Borda]="false"
      [total_registros]="total_registros" 

      [Dados]="dados"
      [Estrutura]="estrutura"
      [EstruturaTotal]="estruturaTotal"
      [EstruturaInterna]="estruturaInterna"
      [ListagemComFiltros]="listagemComFiltros" 
      
      (ver)="ver($event)" 
      (mudarQuantidadePorPagina)="mudarQuantidadePorPagina($event)" 
      (mudarPaginaAtual)="mudarPaginaAtual($event)"
    >
    </app-gridview>
    <div *ngIf="habilitaDetalheMarca">
      <div class="botaoNomeDealer"> 
        <em class="far fa-file-alt"></em>
        &nbsp;&nbsp;&nbsp;&nbsp; {{marca}} &nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:;" (click)="ocultarMarca()">
          <em class="far fa-caret-square-up"></em>
        </a>
      </div>
      <app-gridview 
        [ExibirBotaoDetalhes]="exibirBotaoDetalhes"
        [ExibirIconBotaoDetalhes]="exibirIconBotaoDetalhes"
        [ExibirBotaoDetalhesIcon]="exibirBotaoDetalhesIcon"
        [NomeModulo]="nomeModulo" 
        [totalInterna]="visualizarTotalInterna"
        [totalGeral]="visualizarTotalGeral"
        [visualizarTotalRegistros]="visualizarTotalRegistros"
        [PaginaAtual]="paginaAtual"
        [QuantidadeRegistrosPorPagina]="QuantidadeRegistrosPorPagina"
        [Paginacao]="listagemComPaginacao"
        [Borda]="false"
        [total_registros]="total_registros"

        [Dados]="dadosMarca"
        [Estrutura]="estruturaDetalhe"
        [EstruturaTotal]="estruturaDetalheTotal"
        [ListagemComFiltros]="listagemComFiltros" 
        
        (ver)="ver($event)" 
        (mudarQuantidadePorPagina)="mudarQuantidadePorPagina($event)" 
        (mudarPaginaAtual)="mudarPaginaAtual($event)"
      >
      </app-gridview>
    </div>
  </div>
</div>